import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9cd060c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-technology-timeline" }
const _hoisted_2 = {
  key: 0,
  class: "timeline-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading technology timeline...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "timeline-error"
}
const _hoisted_7 = { class: "timeline-scroll-container" }
const _hoisted_8 = { class: "year-markers" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "year-line" }, null, -1))
const _hoisted_10 = { class: "year-label" }
const _hoisted_11 = { class: "technology-bars" }
const _hoisted_12 = ["onMouseenter"]
const _hoisted_13 = ["src", "alt", "title"]
const _hoisted_14 = { class: "tech-text" }
const _hoisted_15 = ["data-below"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "tech-years" }
const _hoisted_18 = {
  key: 1,
  class: "tech-category"
}
const _hoisted_19 = {
  key: 3,
  class: "timeline-branding"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Technology Timeline", -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "timeline-wrapper",
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hoveredTech = null))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "timeline-content",
                style: _normalizeStyle({ width: _ctx.timelineWidth + 'px' })
              }, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearMarkers, (year) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: year,
                      class: "year-marker",
                      style: _normalizeStyle({ left: _ctx.getYearPosition(year) + 'px' })
                    }, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, _toDisplayString(year), 1)
                    ], 4))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedTechnologies, (tech) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tech.name,
                      class: "technology-bar",
                      style: _normalizeStyle({
                left: _ctx.getTechStartPosition(tech) + 'px',
                width: _ctx.getTechWidth(tech) + 'px',
                top: (tech.row * 40) + 'px',
                backgroundColor: tech.color,
                zIndex: tech.zIndex
              }),
                      onMouseenter: ($event: any) => (_ctx.hoveredTech = tech),
                      onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hoveredTech = null))
                    }, null, 44, _hoisted_12))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedTechnologies, (tech) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `labels-${tech.name}`,
                      class: "technology-labels"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tech.labelPositions, (label, labelIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${tech.name}-label-${labelIndex}`,
                          class: _normalizeClass(["tech-label", { 'entry-label': label.isEntry, 'overlap-label': !label.isEntry }]),
                          style: _normalizeStyle({
                  left: label.x + 'px',
                  top: (tech.row * 40 + 5) + 'px',
                  zIndex: tech.zIndex + 100
                })
                        }, [
                          (tech.logo)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: tech.logo,
                                alt: tech.name,
                                class: "tech-logo",
                                title: tech.name
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(label.text), 1)
                        ], 6))
                      }), 128))
                    ]))
                  }), 128))
                ]),
                (_ctx.hoveredTech && _ctx.hoveredTech.name)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "tech-tooltip",
                      style: _normalizeStyle(_ctx.tooltipStyle),
                      "data-below": _ctx.tooltipShowBelow ? '' : null
                    }, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.hoveredTech.name), 1),
                      (_ctx.hoveredTech.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.hoveredTech.description), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.hoveredTech.startYear) + " - " + _toDisplayString(_ctx.hoveredTech.endYear === 'present' || _ctx.hoveredTech.endYear === _ctx.currentYear ? 'Present' : _ctx.hoveredTech.endYear), 1),
                      (_ctx.hoveredTech.category)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.hoveredTech.category), 1))
                        : _createCommentVNode("", true)
                    ], 12, _hoisted_15))
                  : _createCommentVNode("", true)
              ], 4)
            ])
          ], 32)),
    (_ctx.showBranding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
      : _createCommentVNode("", true)
  ]))
}